import styled from 'styled-components';

export const TrialAlertContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0.5rem;
  background: ${({ theme }: {theme: any}) => theme.themeLighter};
  animation-name: swipeDown;
  animation-duration: 0.5s;

  @keyframes swipeDown {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

export const TrialAlertContent = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;

  svg {
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
  }

  .text {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: ${({ theme }: {theme: any}) => theme.black};

    @media (max-width: 768px) {
      flex-direction: column;
    }

    h1 {
      font: 600 1rem/1rem 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.themeDarker};
    }

    h2 {
      font: 400 0.9rem/0.9rem 'Roboto', sans-serif;
      color: ${({ theme }: {theme: any}) => theme.themeDarkAlt};
    }
  }

  button#upgradeButton {
    display: flex;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    border-radius: 1rem;
    border: none;
    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    color: #fff;
    font: 700 1rem/1rem 'Roboto', sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: ${({ theme }: {theme: any}) => theme.themeDark};
    }
  }
`;
